export const enum ErrorBoundaryLabel {
  INTERSTITIAL_AD = 'interstitial-ad',
  INTERSTITIAL = 'interstitial',
  FIS_VOICE_OF_THE_CUSTOMER = 'voice-of-the-customer-shared-ui',
  SERVICING_AUTHENTICATED_USER = 'servicing.authenticated.user',
  SERVICING_BOOKING = 'servicing.booking',
  SERVICING_IMPORTANT_TRIP_INFORMATION = 'servicing.important.trip.information',
  SERVICING_PAYMENT = 'servicing.payment',
  SERVICING_TRIP_SUMMARY = 'servicing.trip.summary',
  SERVICING_CREDIT_RESIDUAL_MESSAGING = 'servicing.credit.residual.messaging',
  SERVICING_INSURANCE = 'servicing.insurance',
  SERVICING_VOICE_OF_CUSTOMER = 'servicing.voice.of.customer',
  AIRLINE_CREDITS = 'airlines.credits',
  REGULATORY_STATEMENTS = 'regulatory.statements',
  SERVICING_CONFIRMATION = 'servicing.confirmation',
  SERVICING_CONFIRMATION_PLACARDS = 'servicing.confirmation.placards',
  SERVICING_CONFIRMATION_PAGE = 'servicing.confirmation.page',
  SERVICING_CONFIRMATION_VOICE_OF_CUSTOMER = 'servicing.confirmation.voice.of.customer',
  ANCILLARY_SUMMARY = 'ancillary.summary',
  VBS_UPSELL_FSR = 'offer-vbs-upsell-fsr',
  SMART_SHOPPING_LISTINGS = 'smart.shopping.listings',
  SMART_SHOPPING_SKELETONS = 'smart.shopping.skeletons',
  SMART_SHOPPING_HEADER = 'smart.shopping.header',
  SIMILAR_FLIGHTS_WRAPPER = 'similar.flights.wrapper'
}
